import { useTranslation } from 'react-i18next'
import { Text } from '@lounge-fe/ui-kit'
import { NewsletterSignupProps } from './types'
import { DiscountModalTrigger } from '@/components/Modals/DiscountModal'

export const NewsletterSignup = ({
  data: { title, subtitle, button_content },
  children,
  ...props
}: NewsletterSignupProps) => {
  return (
    <div {...props}>
      <Text variant="title-five" className="mb-2">
        {title}
      </Text>
      <Text
        variant="body-sm"
        className="text-subtle mb-3"
        dangerouslySetInnerHTML={{ __html: subtitle }}
      />
      <DiscountModalTrigger as="button">
        <Text variant="body-sm" className="underline text-primary">
          {button_content}
        </Text>
      </DiscountModalTrigger>
    </div>
  )
}
